import Select from '@admin/components/form/select'
import React from 'react'

const CheckboxGroup = React.forwardRef((props, ref) => {
  return <Select { ...props } ref={ ref } multiple={ true } />
})

export default CheckboxGroup